<template>
  <div id="bridge-cable" class="h-full w-full">
    <div class="w-full flex justify-between items-center mb-10px">
      <el-input v-model="keyword" class="!w-[calc(100%-80px)] mr-10px" placeholder="请输入关键词">
      </el-input>
      <el-button @click="getTree">搜索</el-button>
    </div>
    <el-tree
      :props="treeProps"
      :data="treeData"
      :default-checked-keys="defaultCheckedKeys"
      show-checkbox
      node-key="id"
      @node-click="clickNode"
      @check="checkChange"
      class="h-[calc(100%-60px)] overflow-auto !bg-transparent"
    >
    </el-tree>
  </div>
</template>
<script>
import { CableTrayApi } from '@wiz-api/tongre'
import { isJSONObj } from '../../../assets/js/scene/scene.js'
import HandoverService from '../../../service/HandoverService'

const cableTrayApi = new CableTrayApi()

export default {
  name: 'bridgeCable',
  props: {
    /** 场景id */
    sourceId: {
      type: String,
      defalut: '',
    },
    player: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    cloudRender: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      keyword: '',
      treeProps: {
        label: 'name',
        children: 'childrens',
        isLeaf: 'leaf',
      },
      treeData: [],
      defaultCheckedKeys: [],
      standardId: '',
      selectNode: null,
    }
  },
  computed: {
    userId() {
      const userInfo = Wiz.AuthHooks.GetUserInfo()
      const { sub } = userInfo?.profile
      return sub
    },
  },
  methods: {
    async getTree() {
      const [err, res] = await cableTrayApi.getCableTrayTree({
        sceneId: this.sourceId,
        keyWords: this.keyword,
        loginUserId: this.userId,
      })
      if (!err) {
        res.forEach((e) => {
          e.checked = true
        })
        this.defaultCheckedKeys = res.map((o) => {
          return o.id
        })

        this.treeData = res
        res.forEach(async (e) => {
          const node = await this.player.Native.Node.findNode(0, {
            names: [e.name],
            codes: [e.code],
          })

          const info = node.codes ? node.codes[e.code] : node.names ? node.names[e.name] : null
          if (info) {
            this.player.Native.Node.setProperty(info.node, { visible: true })
          }
        })
      }
    },
    async clickNode(data) {
      const { eye, target, up } = JSON.parse(data.angle)
      this.player.Native.Camera.moveTo(eye, target, up, 2)
      if (!info.node) {
        const node = await this.player.Native.Node.findNode(0, {
          names: [data.name],
          codes: [data.code],
        })
        const info = node.codes ? node.codes[data.code] : node.names ? node.names[data.name] : null

        data.node = info.node
        this.selectNode = [info.node]
        this.player.Native.Node.selectNodes(this.selectNode)
      } else {
        this.selectNode = [info.node]

        this.player.Native.Node.selectNodes(this.selectNode)
      }
      const [err, res] = await HandoverService.getInfo({
        code: data.code,
        standardId: this.standardId,
      })
      this.$emit('transferEvent', {
        toCom: { code: 'ObjectInfoDyw', origin: 'NewBridgeCable', name: '对象信息' },
        type: 'business',
        props: data.code
          ? {
            ...res.data[0],
            standardId: this.standardId,
            openAlarmFlicker: true,
            flickerFrequency: 500,
          }
          : {
            standardId: this.standardId,
            openAlarmFlicker: true,
            flickerFrequency: 500,
            code: data.code,
          },
      })
    },
    async checkChange(data, { checkedKeys }) {
      if (!data.node) {
        const node = await this.player.Native.Node.findNode(0, {
          names: [data.name],
          codes: [data.code],
        })
        const info = node.codes ? node.codes[data.code] : node.names ? node.names[data.name] : null
        data.node = info.node
      }

      this.player.Native.Node.setProperty(data.node, { visible: checkedKeys.includes(data.id) })
    },
    async getStandardList() {
      const [err, res] = await HandoverService.getStandardList()
      if (!err && res && res.code === 0 && res.data) {
        this.standardId = res.data[0].id
      } else {
        this.standardId = ''
      }
    },
  },
  async created() {
    const root = await this.player.Native.Node.getRoot()
    await this.player.Native.Node.setProperty(root, { visible: false })
    this.getTree()
    await this.getStandardList()
  },
  async beforeDestroy() {
    const root = await this.player.Native.Node.getRoot()
    await this.player.Native.Node.setProperty(root, { visible: true })

    if (this.selectNode) {
      this.player.Native.Node.unSelectNodes(this.selectNode)
    }
  },
}
</script>

<style lang="scss" scoped>
#bridge-cable {
  background-color: transparent;
  ::v-deep .el-button {
    color: #fff !important;
  }
}

::v-deep .el-tree-node.is-expanded > .el-tree-node__children {
  display: inline;
}
</style>
